import type {Component, PropertyProps} from 'grapesjs';
import type {PrimaryConfigOptions} from '@/email-maker/grapesjs-email-editor-plugin/src';
import {xssCleanHtml} from '@Utils/string.util';

export interface TemplateNameInputProps extends PropertyProps {
  component?: Component;
  cb?: (component: Component, inputVal: string, event: Event) => void;
}

export default (opt: PrimaryConfigOptions): void => {
  const {editor} = opt;
  const styleManager = editor.StyleManager;

  styleManager.addType('pmw-template-name', {
    create(data) {
      const props = data.props as TemplateNameInputProps;

      props.component = props.component ?? editor.getSelected();
      props.icon = props.icon ?? '';

      const wrapper = document.createElement('div');
      const container = document.createElement('div');
      const span = document.createElement('span');
      const input = document.createElement('input');
      const icon = document.createElement('i');

      wrapper.className = `${props.type} template-name-input-wrapper flex-center`;
      container.className = 'field-input-container flex-center _cursor-pointer _fit-width';
      input.className = `field-input bg-neutral-0 body-s content-body js-field-input-${props.property} _hidden`;
      input.id = `input-field`;
      icon.className = 'pmw-icon size-icon-20 icon-pencil content-body spacing-m-l-2 spacing-m-r-0 spacing-m-b-1';
      span.className = 'input-span body-s-bold content-body _fit-width';

      if (props.property) {
        input.value = props.component?.get(props.property) as string;
        span.textContent = input.value;
      }

      container.append(span, input, icon);
      wrapper.append(container);

      container.addEventListener('click', () => {
        container.classList.add('-selected');
        span.classList.add('_hidden');
        icon.classList.add('_hidden');
        input.classList.remove('_hidden');
        input.focus();
        input.select();
      });

      input.addEventListener('blur', (event) => {
        handleInputChange(event, props);
        span.textContent = input.value;
        container.classList.remove('-selected');
        input.classList.add('_hidden');
        span.classList.remove('_hidden');
        icon.classList.remove('_hidden');
      });

      input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') {
          return;
        }
        input.blur();
      });

      return wrapper;
    },
    emit() {},
    update() {},
  });

  function handleInputChange(event: Event, props: TemplateNameInputProps): void {
    const prevValue = props.component?.get(props.property ?? window.PMW.emails.props.TEMPLATE_NAME) as string;

    const target = event.target as HTMLInputElement;
    const inputVal = target.value.trim();

    if (inputVal === '') {
      target.value = prevValue;
      return;
    }

    if (props.component && props.property) {
      props.component.set(props.property, inputVal);
    }

    if (props.cb && props.component) {
      props.cb(props.component, inputVal, event);
    }
  }
};
